import './style.scss';
import DataTable from './datatable.js';

export default DataTable;